import { type SelectOption } from '@factorialco/deprecated-design-system'

import {
  defaultOptions,
  documentOptions,
  groupOptions,
  leaveOptions,
  reviewOptions,
} from 'modules/automations/components/Show/CommonNotification/options'
import {
  defaultRecipientTypes,
  recipientTypes,
} from 'modules/automations/components/Show/CommonNotification/types'
import Notifier from 'modules/automations/store/models/Notifier'

export const userOptions = (notifier: string): SelectOption[] => {
  switch (notifier) {
    case Notifier.Slugs.reviewRequestCompleted:
      return reviewOptions()

    case Notifier.Slugs.documentCreated:
      return documentOptions()

    case Notifier.Slugs.leaveCreated:
    case Notifier.Slugs.leaveUpdated:
      return leaveOptions()

    default:
      return defaultOptions()
  }
}

export { groupOptions, recipientTypes, defaultRecipientTypes }
